export enum TipoCampoAdicionalEnum {
  Texto = 1,
  TextoLongo = 2,
  Numero = 3,
  Moeda = 4,
  Data = 5,
  ListaOpcoes = 6,
}
